webpackJsonp([205611893827833],{

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DBDwall.adbcbb2f.png";

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.0b9658a8.png";

/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (min-width: 300px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    height: 450px;\n  }\n'], ['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (min-width: 300px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    height: 450px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\tposition: fixed;\n\tzIndex: 999;\n\tbackground-image: url(', ');\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n  @media (max-width: 299px) {\n    right: 10%;\n    bottom: 0%;\n    width: 20%;\n    height: 20%;\n  }\n  @media (min-width: 300px) {\n    right: 10%;\n    bottom: 0%;\n    width: 15%;\n    height: 15%;\n  }\n  @media (min-width: 600px) {\n    right: 7%;\n    bottom: 2%;\n    width: 12%;\n    height: 12%;\n  }\n  @media (min-width: 1100px) {\n    right: 2%;\n\t  bottom: 2%;\n\t  width: 15%;\n\t  height: 15%;\n\t}\n\n'], ['\n\tposition: fixed;\n\tzIndex: 999;\n\tbackground-image: url(', ');\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n  @media (max-width: 299px) {\n    right: 10%;\n    bottom: 0%;\n    width: 20%;\n    height: 20%;\n  }\n  @media (min-width: 300px) {\n    right: 10%;\n    bottom: 0%;\n    width: 15%;\n    height: 15%;\n  }\n  @media (min-width: 600px) {\n    right: 7%;\n    bottom: 2%;\n    width: 12%;\n    height: 12%;\n  }\n  @media (min-width: 1100px) {\n    right: 2%;\n\t  bottom: 2%;\n\t  width: 15%;\n\t  height: 15%;\n\t}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(6);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hedron = __webpack_require__(10);
	
	var _colorbar = __webpack_require__(12);
	
	var _colorbar2 = _interopRequireDefault(_colorbar);
	
	var _logo = __webpack_require__(720);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _DBDwall = __webpack_require__(719);
	
	var _DBDwall2 = _interopRequireDefault(_DBDwall);
	
	var _inprogress = __webpack_require__(56);
	
	var _inprogress2 = _interopRequireDefault(_inprogress);
	
	var _index = __webpack_require__(42);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ask = __webpack_require__(55);
	
	var _ask2 = _interopRequireDefault(_ask);
	
	var _reactScrollableAnchor = __webpack_require__(18);
	
	var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ImageWrapper = _styledComponents2.default.div.attrs({
	
	  image: function image(props) {
	    return props.image;
	  }
	})(_templateObject, function (props) {
	  return props.image;
	});
	
	var DownloadIconContainer = _styledComponents2.default.div(_templateObject2, _ask2.default);
	
	var ImgColStyle = {
	  padding: '0'
	};
	
	var RowStyleEVEN = {
	  background: '#F9F9F9'
	};
	
	var RowStyleODD = {
	  background: '#F5F5F5'
	};
	
	var About = function About(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: '#download' },
	      _react2.default.createElement(DownloadIconContainer, null)
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleEVEN },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _logo2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            'u',
	            { style: { textDecoration: 'none', borderBottom: '10px solid #DFAB50' } },
	            'DBD Pier'
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Displacement-Based design for Single Degree of Freedom Systems, with particular reference to bridge piers. For a given target drift, this app provides the detailing of a circular bridge pier to comply with a given seismic demand'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _DBDwall2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            'u',
	            { style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
	            'Completely standalone'
	          ),
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'You don\u2019t need any other software to run it'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleEVEN },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _inprogress2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            'u',
	            { style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
	            'Work in progress'
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'This app is under development'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      null,
	      _react2.default.createElement(
	        _reactScrollableAnchor2.default,
	        { id: 'download' },
	        _react2.default.createElement(
	          _hedron.Column,
	          { xs: 12, sm: 12, smShift: 0, md: 10, mdShift: 1, lg: 8, lgShift: 2 },
	          _react2.default.createElement(_index2.default, { formname: 'dbdpier' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-dbd-p-index-en-jsx-74a022792795bf15c8f5.js